
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/avis-commentaires",
      function () {
        return require("private-next-pages/[region]/[resort]/avis-commentaires.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/avis-commentaires"])
      });
    }
  